import { MF_PARTICULAR_HOLDING_DATA, MF_PARTICULAR_HOLDING_ERROR, MF_PARTICULAR_HOLDING_HIDE_ERROR, MF_PARTICULAR_HOLDING_START_LOADER, MF_PARTICULAR_HOLDING_STOP_LOADER, } from "../interface/IMFParticularHolding";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const mfParticularHolding = (state = initState, action) => {
    switch (action.type) {
        case MF_PARTICULAR_HOLDING_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case MF_PARTICULAR_HOLDING_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case MF_PARTICULAR_HOLDING_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        case MF_PARTICULAR_HOLDING_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case MF_PARTICULAR_HOLDING_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        default:
            return Object.assign({}, state);
    }
};
export default mfParticularHolding;
